import { render, staticRenderFns } from "./EmArchBasicDataEdit.vue?vue&type=template&id=e3fbf0f4&"
import script from "./EmArchBasicDataEdit.vue?vue&type=script&lang=js&"
export * from "./EmArchBasicDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports